import css from 'styled-jsx/css';

const styles = css.global`#energia-solar-economia {
  background: #FFF;
  margin-top: 32px;
}

#energia-solar-economia .energia-solar-economia-p1 .economia-textos {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

#energia-solar-economia .energia-solar-economia-p1 .economia-textos .economia-textos-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px;
}

#energia-solar-economia .energia-solar-economia-p1 .economia-textos picture {
  width: 100%;
  display: flex;
  justify-content: center;
}

#energia-solar-economia .energia-solar-economia-p1 picture img {
  border-radius: 4px;
}

#energia-solar-economia .energia-solar-economia-p1 .economia-textos .economia-textos-texto {
  color: #222;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#energia-solar-economia .energia-solar-economia-p1 .economia-textos .economia-textos-texto b {
  color: #222;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#energia-solar-economia .energia-solar-economia-p1 .economia-textos .economia-textos-btn {
  width: 100%;
  max-width: 288px;
  height: 48px;
  position: relative;
  margin: 16px auto 0;
}





#energia-solar-economia .energia-solar-economia-p2 {
  padding: 40px 0 40px;
}

#energia-solar-economia .energia-solar-economia-p2 .vantagens-titulo {
  color: #222;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin-bottom: 32px;
}

#energia-solar-economia .energia-solar-economia-p2 .custom-carousel .embla__container {
  max-width: 1155px;
  margin: auto;
}

#energia-solar-economia .energia-solar-economia-p2 .slide {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 199px;
  height: 192px;
  padding: 24px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #CCC;
  margin-right: 16px;
  flex: 0 0 199px;
}

#energia-solar-economia .energia-solar-economia-p2 .slide .slide-texo {
  color: #222;
  text-align: center;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#energia-solar-economia .home-pagination {
  margin-top: 48px;
  max-width: 256px;
}

#energia-solar-economia .home-pagination .embla__prev.enable-mobile-arrows, 
#energia-solar-economia .home-pagination .embla__next.enable-mobile-arrows {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

#energia-solar-economia .img-separador-vantagens {
  display: flex;
}

#energia-solar-economia .energia-solar-separador {
  margin: 40px auto 16px;
  padding-right: 16px;
  padding-left: 16px;
  max-width: 915px;
}

#energia-solar-economia .energia-solar-separador .slide {
  display: flex;
  width: 288px;
  flex: 0 0 288px;
  margin-right: 16px;
}

#energia-solar-economia .energia-solar-separador .slide img {
  border-radius: 4px;
}
#energia-solar-economia .energia-solar-separador .slide:last-child {
  margin-right: 0;
}

#energia-solar-economia .energia-solar-separador .home-pagination {
  display: none;
}

@media (min-width: 992px) {
  #energia-solar-economia {
    margin-top: 40px;
    overflow: hidden;
  }

  #energia-solar-economia .energia-solar-economia-p1 .ctn-home-24 {
    display: flex;
    gap: 36px;
  }
  #energia-solar-economia .energia-solar-economia-p1 .economia-textos {
    gap: 24px;
    flex: 50%;
  }

  #energia-solar-economia .energia-solar-economia-p1 .economia-textos .economia-textos-titulo {
    font-size: 56px;
    line-height: 120%;
  }

  #energia-solar-economia .energia-solar-economia-p1 picture {
    width: 42%;
  }

  #energia-solar-economia .energia-solar-economia-p1 picture img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    object-fit: cover;
  }

  #energia-solar-economia .energia-solar-economia-p1 .economia-textos .economia-textos-btn {
    max-width: 250px;
    margin: 8px 0 0;
  }




  

  #energia-solar-economia .energia-solar-economia-p2 {
    padding: 88px 0 64px;
  }

  #energia-solar-economia .energia-solar-economia-p2 .slide {
    margin-right: 40px;
  }

  #energia-solar-economia .energia-solar-economia-p2 .slide:last-child {
    margin-right: 0;
  }
  #energia-solar-economia .home-pagination {
    display: none;
  }

  #energia-solar-economia .energia-solar-separador {
    margin: 64px auto 48px;
    padding-right: 0;
    padding-left: 0;
    max-width: 1445px;
  }

  #energia-solar-economia .energia-solar-separador .slide {
    width: 469px;
    flex: 0 0 469px;
  }
}
`;

export default styles;